<mat-card class="mb-4 rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
  <div class="mb-3 flex items-center justify-between gap-3">
    <h3 class="text-lg font-semibold text-slate-900">Referral preferences</h3>
    @if (canEdit() && !editing()) {
      <button mat-stroked-button type="button" (click)="edit()">{{ isEmpty() ? 'Record preferences' : 'Edit' }}</button>
    }
  </div>

  @if (editing()) {
    <form [formGroup]="form" (submit)="$event.preventDefault(); save()" class="grid gap-6">
      <p class="text-sm text-slate-500">
        These rank the affiliates when the referral is issued: an affiliate that matches more of them is offered first. Leave a field empty for no preference.
      </p>
      <!-- What the member and the clinician prefer; the lists come from the reference data -->
      <div class="grid gap-x-4 md:grid-cols-3">
        <lookup-select formControlName="counsellingTypeId" label="Counselling type" [options]="counsellingTypes()" noneLabel="No preference" />
        <lookup-select formControlName="preferredLanguageId" label="Language" [options]="languages()" noneLabel="No preference" />
        <lookup-select formControlName="preferredCounsellingMediumId" label="Preferred medium" [options]="mediums()" noneLabel="No preference" />
        <lookup-select formControlName="preferredAffiliateGenderId" label="Affiliate gender" [options]="genders()" noneLabel="No preference" />
        <lookup-select formControlName="preferredAffiliateReligionId" label="Affiliate religion" [options]="religions()" noneLabel="No preference" />
        <mat-form-field appearance="outline">
          <mat-label>Suburb</mat-label>
          <input matInput maxlength="200" formControlName="preferredSuburb" />
          <mat-hint>Only affiliates who serve this suburb are offered the referral.</mat-hint>
        </mat-form-field>
      </div>

      <section class="grid gap-2">
        <h4 class="font-semibold text-slate-900">Special needs</h4>
        <div class="grid gap-2 md:grid-cols-2">
          @for (item of specialNeedTypes(); track item.id) {
            <div class="grid gap-1">
              <mat-checkbox [checked]="isSpecialNeedChosen(item.id)" (change)="toggleSpecialNeed(item.id, $event.checked)">{{ item.name }}</mat-checkbox>
              @if (isSpecialNeedChosen(item.id) && isOther(specialNeedTypes(), item.id)) {
                <mat-form-field appearance="outline">
                  <mat-label>Describe the need</mat-label>
                  <input matInput maxlength="500" [value]="chosenSpecialNeeds()[item.id]" (input)="setSpecialNeedDetail(item.id, $any($event.target).value)" />
                </mat-form-field>
              }
            </div>
          }
        </div>
      </section>

      <section class="grid gap-2">
        <h4 class="font-semibold text-slate-900">Additional services</h4>
        <div class="grid gap-2 md:grid-cols-2">
          @for (item of supportServiceTypes(); track item.id) {
            <div class="grid gap-1">
              <mat-checkbox [checked]="isServiceChosen(item.id)" (change)="toggleService(item.id, $event.checked)">{{ item.name }}</mat-checkbox>
              @if (isServiceChosen(item.id)) {
                <mat-form-field appearance="outline">
                  <mat-label>Notes</mat-label>
                  <input matInput maxlength="500" [value]="chosenServices()[item.id]" (input)="setServiceNotes(item.id, $any($event.target).value)" />
                </mat-form-field>
              }
            </div>
          }
        </div>
      </section>

      <div class="flex justify-end gap-2">
        <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
        <button mat-flat-button type="submit" [disabled]="store.savingReferralPreference()">
          @if (store.savingReferralPreference()) {
            <mat-spinner diameter="20" class="mr-2" />
          }
          Save preferences
        </button>
      </div>
    </form>
  } @else if (isEmpty()) {
    <p class="text-sm text-slate-500">No preferences have been recorded. The affiliates are offered the referral in order of workload.</p>
  } @else {
    <dl class="grid gap-x-6 gap-y-2 text-sm md:grid-cols-2">
      @for (row of summary(store.referralPreference()); track row.label) {
        <div class="flex gap-2">
          <dt class="w-40 shrink-0 text-slate-500">{{ row.label }}</dt>
          <dd class="font-medium text-slate-900">{{ row.value }}</dd>
        </div>
      }
    </dl>
  }
</mat-card>
